import { defaultsDeep } from 'lodash-es'
import { FC, PropsWithChildren } from 'react'

import { CarbonOffsetStrategy } from '../QuoteServices'
import { CustomerPreference } from './CustomerPreference'
import { CustomerPreferenceContext, CustomerPreferenceStore } from './CustomerPreferenceContext'

export type MockCustomerPreferenceStore = Partial<Omit<CustomerPreferenceStore, 'customerPreference'>> & {
  customerPreference?: Partial<CustomerPreference>
}

const mockStore: CustomerPreferenceStore = {
  customerPreference: {
    customerId: 'C-1000',
    sustainability: { offsetShipmentsByDefault: CarbonOffsetStrategy.None },
    _id: '60af9666be15e4be21da9b78',
  },
  setCustomerPreference: () => null,
}

type CustomerPreferenceContextProviderMockProps = {
  storeOverride?: MockCustomerPreferenceStore
}

export const CustomerPreferenceContextProviderMock: FC<
  PropsWithChildren<CustomerPreferenceContextProviderMockProps>
> = ({ children, storeOverride }) => {
  const store = defaultsDeep(storeOverride, mockStore)
  return <CustomerPreferenceContext.Provider value={store}>{children}</CustomerPreferenceContext.Provider>
}
